const SELECTOR_TRIGGER = '.js-header-menu-trigger';
const SELECTOR_ITEM = '.js-header-menu-item';

const boundTriggers = new WeakSet<HTMLElement>();

export function initHeaderMenu(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const triggers = document.querySelectorAll<HTMLElement>(SELECTOR_TRIGGER);

  for (const trigger of triggers) {
    const item = trigger.closest<HTMLElement>(SELECTOR_ITEM);

    if (item == null || boundTriggers.has(trigger)) {
      continue;
    }

    boundTriggers.add(trigger);

    const syncExpanded = (): void => {
      trigger.setAttribute(
        'aria-expanded',
        item.matches(':hover, :focus-within') ? 'true' : 'false',
      );
    };

    item.addEventListener('mouseenter', syncExpanded);
    item.addEventListener('mouseleave', syncExpanded);
    item.addEventListener('focusin', syncExpanded);
    item.addEventListener('focusout', (event) => {
      if (item.contains(event.relatedTarget as Node | null)) {
        return;
      }

      trigger.setAttribute(
        'aria-expanded',
        item.matches(':hover') ? 'true' : 'false',
      );
    });
  }
}
